import { Component, OnInit, NgZone } from "@angular/core";
import { MapsAPILoader } from "@agm/core";

import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

import { validateConfig } from "@angular/router/src/config";
import { ServicesService } from "../../services/services.service";
import { environment } from "../../../environments/environment";
import swal from "sweetalert2";
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-create-construction",
  templateUrl: "./create-construction.component.html",
  styleUrls: ["./create-construction.component.css"]
})
export class CreateConstructionComponent implements OnInit {
  public routePath;

  //variable for search fields (orders)
  orders = [];
  selectedOrderList = [];
  submitted = false;
  selectedItems = [];
  dropdownSettings: any = {};
  ShowFilter = true;
  totalContractor = [];
  addConstructionForm: FormGroup;
  isFormSubmitted = false;
  showloader = false;
  totalUnitsMatchError = false;
  //variable defined for static data
  productList = [];
  fields = [];
  listData = [];
  optval;
  muncipality = [];
  maintainid: any;

  constructor(private modalService: NgbModal, private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, private _services: ServicesService, private formBuilder: FormBuilder, private activeroute: ActivatedRoute) {
    this.activeroute.queryParams.subscribe(params => {
      this.maintainid = params["maintenance_id"];
      // //console.log(this.maintainid);
    });
  }

  mapTitle: string;
  closeResult: string;
  mapFor: string;
  isLoader: boolean = false;

  initializeMap() {
    this.zoom = 10;
    this.latitude = -25.71753;
    this.longitude = 28.03136;
  }
  contLength: any;

  // addContractor(index) {
  //   this.totalContractor.push(this.totalContractor.length);
  //   // this.addConstructionForm = new FormGroup({
  //   //   'contractor_name': new FormControl('', [Validators.required]),
  //   //   'contractor_unit': new FormControl('', [Validators.required]),
  //   // })
  //   // //console.log(this.addConstructionForm.value);
  //   this.contLength = this.totalContractor.length;
  //   //console.log(this.contLength);
  // }

  // removeContractor(index){
  //   //console.log(cont_no);
  //   this.totalContractor.pop();
  //   this.contLength = this.contLength-1;
  //   //console.log(this.contLength);
  // }
  /*-----------------------------------Model pop up-----------------------------*/

  open(content, event) {
    this.modalService.open(content).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    this.mapTitle = "Select your area";

    /*-----------------Get clicked element---------------*/
    var target = event.target || event.srcElement || event.currentTarget;
    //console.log(target);
    var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;

    this.routeLocation = this.project_location["project-location"];
    this.mapFor = value;
    this.requestedMap = this.mapFor == "project-location-map" ? "project-location" : "source";
    //console.log(this.requestedMap);

    //console.log(this.routeLocation);
    this.geoCodeAddress(this.routeLocation);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  /*-----------------------------------Model pop up-----------------------------*/

  /*----------------------------------Google API--------------------------------*/
  project_location: Object = {};
  routeLocation: string;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public formatted_address: string;
  public dataToSend: Object = {};
  requestedMap: string;

  // Get Target Element
  getElement(event, valueFor) {
    //console.log(valueFor);
    var element = event.target || event.srcElement || event.currentTarget;

    //this.searchPlaces(element, valueFor);
    this.requestedMap = valueFor;
  }

  mapClicked($event: MouseEvent) {
    /*
     this.markers.push({
     lat: $event.coords.lat,
     lng: $event.coords.lng,
     draggable: true
     });
     */

    this.markerMoved($event);
  }

  markerMoved(e) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: e.coords }, (res, status) => {
      if (status === google.maps.GeocoderStatus.OK && res.length) {
        this.ngZone.run(() => this.setLocation(res[0]));
      }
    });
  }

  setLocation(place) {
    this.latitude = place.geometry.location.lat();
    this.longitude = place.geometry.location.lng();

    //console.log(this.latitude + "----------" + this.longitude);

    var latlng = { lat: <number>this.latitude, lng: <number>this.longitude };
    this.project_location[this.requestedMap + "LatLong"] = this.latitude + ", " + this.longitude;

    this.geoCodeLatLng(latlng);
  }

  geoCodeAddress(address) {
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          //map.setCenter(results[0].geometry.location);
          ////console.log(results[0].geometry.location);

          this.ngZone.run(() => {
            this.setLocation(results[0]);
          });

          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.zoom = 12;
          //console.log(this.latitude + ", " + this.longitude);
        } else {
          //console.log("Geocode was not successful for the following reason: " + status);
        }
      });
    });
  }

  geoCodeLatLng(latlng) {
    ////console.log(latlng);
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (results[0]) {
          this.project_location[this.requestedMap] = results[0].formatted_address;
        }
        ////console.log(this.requestedMap);
        ////console.log(this.project_location[this.requestedMap]);
      });
    });
  }

  setMapForLocation(address) {
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        this.project_location[this.requestedMap + "LatLong"] = results[0].geometry.location.lat() + ", " + results[0].geometry.location.lng();
        ////console.log(this.project_location[this.requestedMap+'LatLong']);
      });
    });
  }

  searchPlaces(e, valueFor) {
    this.mapsAPILoader.load().then(() => {
      let deliveryAddressAutocomplete = new google.maps.places.Autocomplete(e, {
        types: ["address"],
        componentRestrictions: { country: "in" }
      });

      ////console.log(deliveryAddressAutocomplete);
      //---------------------------load Places Autocomplete-----------
      deliveryAddressAutocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = deliveryAddressAutocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.formatted_address = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;

          this.project_location[valueFor] = place.formatted_address;
          this.project_location[valueFor + "LatLong"] = this.latitude + ", " + this.longitude;
        });
      });
    });
  }

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        //this.zoom = 14;
      });
    }
  }

  dir = undefined;
  options = {
    suppressMarkers: true,
    draggable: true,
    travelMode: "DRIVING"
  };
  /*----------------------------------Google API--------------------------------*/

  getEmployees() {
    this.routePath = "get-employee-names";
    let data = {};
    const token = localStorage.getItem("userToken");
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        this.listData = result.result;
      }
    });
    return true;
  }

  getMunicipality() {
    this.routePath = "get-municipality-names";
    let data = {};
    const token = localStorage.getItem("userToken");
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        // this.muncipality = result.result;
        // //console.log(this.muncipality);
      }
    });
    return true;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.addConstructionForm.controls;
  }

  getmuniciplaities(val) {
    // alert(val);
    this.routePath = "get-municipalities";
    // alert(this.addMaintenanceOrderForm.value['project_type']);
    this._services.requestCreator(this.addConstructionForm.value, this.routePath, this._services.getToken()).subscribe((data: any) => {
      // alert('hertre');
      this._services.checkToken(data.status);
      if (data) {
        this.muncipality = data;
        //console.log(this.muncipality);
        for (let i = 0; i < this.muncipality.length; i++) {
          //console.log(this.muncipality[i]);
        }
        // alert(this.muncipality);
        // this.showloader = false;
        // this.isFormSubmitted=false;
        // alert('successful');
      }
    });
  }

  addConstruction() {
    this.isFormSubmitted = true;
    this.showloader = true;
    // stop here if form is invalid

    if (this.addConstructionForm.invalid || this.project_location["project-location"] == "") {
      this.showloader = false;
      return;
    }

    if (this.addConstructionForm.status != "VALID") {
      this.showloader = false;
      this.isFormSubmitted = false;
      return false;
    }

    var arrayControl = this.addConstructionForm.get("contractor_details") as FormArray;
    //console.log("arrayControl", arrayControl);
    //console.log("arrayControl", arrayControl.value);
    let contractorUnitArray = arrayControl.value;
    let totalUnit = 0;
    for (let i = 0; i < contractorUnitArray.length; i++) {
      totalUnit = totalUnit + parseInt(contractorUnitArray[i].contractor_unit);
    }
    let project_unit = this.addConstructionForm.get("project_unit").value;
    if (project_unit != totalUnit) {
      this.totalUnitsMatchError = true;
      this.showloader = false;
      this.isFormSubmitted = false;
      return;
    }

    ////console.log(this.project_location['project-location']);
    this.addConstructionForm.value.lat = this.latitude;
    this.addConstructionForm.value.lng = this.longitude;
    this.addConstructionForm.value.project_location = this.project_location["project-location"];
    //console.log(this.contractorDetails.length);

    this._services.requestCreator(this.addConstructionForm.value, "insert-construction-project", this._services.getToken()).subscribe(
      (data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.showloader = false;
          this.isFormSubmitted = false;
          swal({
            title: "Constructions",
            text: "Construction Added Successfully",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes"
          }).then(() => {
            this.project_location["project-location"] = "";
            this.initializeMap();
            this.addConstructionForm.reset();
            for (let i = this.contractorDetails.length; i >= 1; i--) {
              this.contractorDetails.removeAt(i);
            }
            this.showDelButton = false;
          });
        } else {
          this.showloader = false;
          this.isFormSubmitted = false;
        }
      }
      /*
        (err: HttpErrorResponse) => {
        }
        */
    );
  }

  resetClientForm() {
    this.addConstructionForm.reset();
  }

  changeTotalUnitsMatchError() {
    this.totalUnitsMatchError = false;
  }

  ngOnInit() {
    // this.addContractor(1);
    this.getEmployees();
    this.getMunicipality();
    this.initializeMap();
    this.optval = "";
    this.addConstructionForm = new FormGroup({
      project_name: new FormControl("", [Validators.required]),
      //'project_location': new FormControl('', [Validators.required]),
      project_start_date: new FormControl("", [Validators.required]),
      municipality: new FormControl("", [Validators.required]),
      project_manager_name: new FormControl("", [Validators.required]),
      project_manager_no: new FormControl("", [Validators.required]),
      project_unit: new FormControl("", [Validators.required]),
      user_id: new FormControl("", [Validators.required]),
      maintenance_id: new FormControl(""),
      project_type: new FormControl("", [Validators.required]),
      school_name: new FormControl(""),
      emis_number: new FormControl(""),
      sgb_chairman: new FormControl(""),
      contractor_details: this.formBuilder.array([
        this.formBuilder.group({
          contractor_name: ["", Validators.required],
          contractor_unit: ["", Validators.required]
        })
      ])
      // 'contractor_name': new FormControl('', [Validators.required]),
      // 'contractor_unit': new FormControl('', [Validators.required]),
    });
  }

  get contractorDetails() {
    return this.addConstructionForm.get("contractor_details") as FormArray;
  }

  showDelButton: any;
  addContractor() {
    this.showDelButton = true;
    this.submitted = false;
    this.contractorDetails.push(
      this.formBuilder.group({
        contractor_name: ["", Validators.required],
        contractor_unit: ["", Validators.required]
      })
    );
  }

  removeContractor(index) {
    //console.log(index);
    if (this.contractorDetails.length === 2) {
      this.showDelButton = false;
    }
    this.submitted = false;
    this.contractorDetails.removeAt(index);
    // this.uploadedFiles.splice(index, 1);
  }
}
